import { combineReducers } from "redux";
import dashboardReducer from "./dashboard";
import customersReducers from "./customers";
import customerDetailsReducer from "./customer-details";
import responseStatusReducer from "./status";
import userReducer from "./user";

const appReducers = combineReducers({
  dashboard: dashboardReducer,
  customers: customersReducers,
  customer: customerDetailsReducer,
  responseStatus: responseStatusReducer,
  user: userReducer,
});

const rootReducer = (state, action) => {
  return appReducers(state, action);
};

export default rootReducer;
